export enum ExternalLoadQPStatus {
  Draft = "DRAFT",
  NotRequested = "NOTREQUESTED",
  Pending = "PENDING",
  Approved = "APPROVED",
  Rejected = "REJECTED",
}
